import { render } from "./News.vue?vue&type=template&id=56bed313&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=56bed313&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bed313"]])

export default __exports__